import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: '01',
        title: 'Architecture',
        image: require('./../../images/products/p1.jpg'),
    },
    {
        count: '02',
        title: 'Planning',
        image: require('./../../images/products/p2.jpg'),
    },
    {
        count: '03',
        title: 'Exterior',
        image: require('./../../images/products/p3.jpg'),
    },
    {
        count: '04',
        title: 'Decoration',
        image: require('./../../images/products/p4.jpg'),
    },
    {
        count: '05',
        title: 'Interior Planing',
        image: require('./../../images/products/p5.jpg'),
    },
    {
        count: '06',
        title: 'Style Selection',
        image: require('./../../images/products/p6.jpg'),
    },
    {
        count: '07',
        title: 'Architecture',
        image: require('./../../images/products/p7.jpg'),
    },
    {
        count: '08',
        title: 'Planning',
        image: require('./../../images/products/p8.jpg'),
    },
    {
        count: '09',
        title: 'Planning',
        image: require('./../../images/products/p9.jpg'),
    }
    ,
    {
        count: '10',
        title: 'Planning',
        image: require('./../../images/products/p10.jpg'),
    }
    ,
    {
        count: '11',
        title: 'Planning',
        image: require('./../../images/products/p11.jpg'),
    }
    ,
    {
        count: '12',
        title: 'Planning',
        image: require('./../../images/products/p12.jpg'),
    }
    ,
    {
        count: '13',
        title: 'Planning',
        image: require('./../../images/products/p13.jpg'),
    }
    ,
    {
        count: '14',
        title: 'Planning',
        image: require('./../../images/products/p14.jpg'),
    }
    ,
    {
        count: '159',
        title: 'Planning',
        image: require('./../../images/products/p15.jpg'),
    }
]

var bgimg1 = require('./../../images/background/cross-line2.png');
var bgimg2 = require('./../../images/background/cross-line2.png');

class WhatWeDo3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full  mobile-page-padding bg-white  p-t40 p-b30 bg-repeat overflow-hide" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="sx-separator-outer separator-center">
                                <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg2 + ')' }}>
                                    <h3 className="sep-line-one">Our Products</h3>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        <div className="section-content">
                            <div className="row number-block-three-outer justify-content-center">
                                {services.map((item, index) => (
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 m-b30" key={index}>
                                        <div className="number-block-three slide-ani-top">
                                            <div className="sx-media">
                                                <img src={item.image} alt="" />
                                            </div>
                                            {/* <div className="figcaption bg-gray  p-a30">
                                                <h4 className="m-tb0"><NavLink to={"/services-detail"}>{item.title}</NavLink></h4>
                                                <div className="figcaption-number animate-top-content">
                                                    <span>{item.count}</span>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default WhatWeDo3;